import * as React from "react";
const SvgVkontakte = (props) => /* @__PURE__ */ React.createElement("svg", { width: "800px", height: "800px", viewBox: "0 0 9 9", xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#ffffff", d: "M4.818 6.757C2.382 6.757.992 5.063.934 2.243h1.22c.04 2.07.94 2.946 1.653 3.127V2.243h1.15v1.785c.703-.077 1.443-.89 1.692-1.785H7.8c-.192 1.102-.994 1.916-1.564 2.25.57.271 1.483.98 1.83 2.264H6.802c-.272-.858-.95-1.523-1.844-1.613v1.613z", style: {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.375,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none",
  strokeOpacity: 1
} }));
export default SvgVkontakte;
